import { createStore } from 'vuex';

// 1. IMPORTA o objeto com todos os módulos que o seu index.js dinâmico criou.
import modules from './modules';

const store = createStore({
  // 2. PASSA esse objeto para a propriedade 'modules' do Vuex.
  //    Esta é a linha mais importante e provavelmente a que está faltando ou incorreta.
  modules,

  // Você pode ter outras configurações aqui, como o modo estrito.
  strict: process.env.NODE_ENV !== 'production',
});

export default store;